module.exports = __webpack_public_path__ + "img/sit.46dd8f14.jpg";